
import {useState,useEffect,useContext,useCallback, memo } from 'react'
import {getAll} from '../../Data/Utils';
import {buildItemsList} from '../../Data/GeneralFanction';
import { useParams } from 'react-router-dom';


import Filter from '../Filter/Filter';
 import Table from '../Table/Table';
//import {Table} from '../../Table/Table';
import { LanguageContext } from '../../context';
import Categories from '../Categories/Categories';
import { useQueryParam, NumberParam, StringParam } from 'use-query-params';


const DataSet = () => {

    const [allDataSets,setAllDataSets]=useState([]);
    const [filters,setFilters]=useState([{categoryF:'',typeF:'',categoryId:''}]);    
    const {categoryFilter,typeSearch}=useParams();
    const {language}=useContext(LanguageContext);

    const [categoryF, setCategoryF] = useQueryParam('categoryF', StringParam);
    const [typeF, setTypeF] = useQueryParam('typeF', StringParam);
    const [freeText, setFreeText] = useQueryParam('k', StringParam);
    
    
    

    useEffect(()=>{
        const getDataSets = async () => {
          
            const apiUrl=config.apiUrl;
            const webUrl= window.srcSiteUrl;//process.env.REACT_APP_APIURL;
            const categoriesList=config.lists.dataSet.name; 
            const view=config.lists.dataSet.view;
            let { data: dataSetsAll } = await getAll(`${webUrl}${apiUrl}?listName=${categoriesList}&view=${view}`);
            var x=buildItemsList(dataSetsAll);
            setAllDataSets(x) ;
        };
      var config = require('../../config.json');
      //var config = require('"%PUBLIC_URL%/config.json');
      
      
        getDataSets(); 
            
        //setFilters({categoryF:categoryFilter,typeF:typeSearch,categoryId:categoryFilter}); 
      
      },[]);

      useEffect(()=>{
        FilterData();
      },[filters.categoryF,filters.typeF]);

      const FilterData=()=>{
        // if(categoryFilter!=filters.categoryId){
        //   setFilters(...{ categoryId:categoryFilter})
        // }
        let currentLang=language=="he"?"heb":language;
        if(freeText!==undefined){
          return allDataSets.filter( f=>f.ds_category.Value.includes(`${freeText}`)
          || (f["ds_name_"+currentLang]!=null && f["ds_name_"+currentLang].Value.toLocaleLowerCase().includes(`${freeText.toLocaleLowerCase()}`))
          || (f["ds_desc_"+{language}]!=null && f["ds_desc_"+{language}].Value.toLocaleLowerCase().includes(`${freeText.toLocaleLowerCase()}`))
          || (f["ds_additional_info_"+{language}]!=null  && f["ds_additional_info_"+{language}].Value.toLocaleLowerCase().includes(`${freeText.toLocaleLowerCase()}`))
          || (language=="en" && f.ds_category_x003a_Title_en.Value.toLocaleLowerCase().includes(`${freeText.toLocaleLowerCase() }`)));
        }
        if((categoryF!= undefined && categoryF!='')|| ( typeF!=undefined && typeF!='')){

          var data=[];   
          
          if(typeF!= undefined && typeF.length>0){
            var vf= typeF.split(','); 
            for(var i=0;i<vf.length;i++){
              var fieldCopm=''
              switch(vf[i].toLocaleLowerCase()){
                case 'table':fieldCopm=language=="he"?'ds_url':'ds_url_en';
                break;
                case 'map':fieldCopm='map_url_'+language;
                break;
                case 'graph':fieldCopm='graph_url_'+language;
                break;
                case 'api':fieldCopm='ds_api_base_url';
                break;
                case 'is live':fieldCopm='ds_islive';
                break;

                

              }
              data=data.concat(allDataSets.filter( f=>f[fieldCopm].Value!=null && f[fieldCopm].Value.toLocaleLowerCase()!='false'));
            }
           // fieldCopm+=vf[i]+"_url_"+language+",";
          }
          // switch(filters.typeF){
          //   case "map":fieldCopm='graph_url_'+language;
          // }
          if(categoryF.length>0){
            var currentData=allDataSets;
            if(data.length>0){
              currentData=data;
              data=[];
            }
            var cf= categoryF.split(','); 
           
            for(var i=0;i<cf.length;i++){
              data=data.concat(currentData.filter( 
                f=>f.ds_category.Value.replace("#","").split(';').find(
                  x=>x==cf[i] ||x==`#${cf[i]}`)));
              
            }
           
          }

          const dataDistict = Array.from(new Set(data.map(a => a.ID.Value)))
          .map(id => {
            return data.find(a => a.ID.Value === id)
          })
           return dataDistict;
        }
        if(categoryFilter!=undefined && categoryFilter.trim().length > 0){
          return allDataSets.filter( f=>f.ds_category.Value.toLocaleLowerCase().includes(`${categoryFilter.toLocaleLowerCase()};`));
        }
       

        return allDataSets;
            

       
        
      };


      // const changeFilters=((categoryF,typeF,categoryId)=>{
      //   setFilters({categoryF,typeF,categoryId});
      // })


      

  return (
<>

{/* <Filter /> */}
    <Table data={FilterData()} rowsPerPage={10} />
   </>
  )
}

export default memo(DataSet) 